import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from '@if/core/yup'
import {
  BaseWorksheetFormConfig,
  BaseWorksheetFormValues,
  useBaseWorksheetFormFields,
  useBaseWorksheetFormReady,
} from '@src/components/WorksheetForm'
import { useMemo } from 'react'
import { Resolver } from 'react-hook-form'

export type CalculatorValues = BaseWorksheetFormValues

export const useCalculatorSchema = (config: BaseWorksheetFormConfig) => {
  const fields = useBaseWorksheetFormFields(config)

  return useMemo(
    () =>
      yup.object({
        amountRequested: fields.amountRequested,
        paymentPlanId: fields.paymentPlanId,
        term: fields.term,
        paymentFrequency: fields.paymentFrequency,
        activationDate: fields.activationDate,
        firstPaymentDate: fields.firstPaymentDate,
        includeProtection: fields.includeProtection,
        isHighEstimate: fields.isHighEstimate,
      }),
    [fields],
  )
}

export const useCalculatorForm = (config: BaseWorksheetFormConfig) => {
  const schema = useCalculatorSchema(config)
  const isReady = useBaseWorksheetFormReady(config)

  const resolver = useMemo(() => yupResolver(schema) as Resolver<CalculatorValues>, [schema])
  const defaultValues = useMemo(() => (isReady ? (schema.getDefault() as CalculatorValues) : null), [isReady, schema])

  return { resolver, defaultValues, isReady }
}
